export enum CurrencyCode {
  USD = 'USD', // United States Dollar
  EUR = 'EUR', // Euro Member Countries
  AED = 'AED', // Arab Emirates Dirham
  AFN = 'AFN', // Afghanistan Afghani
  AMD = 'AMD', // Armenian dram
  ANG = 'ANG', // Netherlands Antilles Guilder
  AOA = 'AOA', // Angolan kwanza
  ARS = 'ARS', // Argentina Peso
  AUD = 'AUD', // Australia Dollar
  AWG = 'AWG', // Aruba Guilder
  AZN = 'AZN', // Azerbaijan Manat
  BAM = 'BAM', // Bosnia and Herzegovina Convertible Mark
  BBD = 'BBD', // Barbados Dollar
  BDT = 'BDT', // Bangladeshi taka
  BGN = 'BGN', // Bulgaria Lev
  BHD = 'BHD', // Bahraini dinar
  BIF = 'BIF', // Burundian franc
  BMD = 'BMD', // Bermuda Dollar
  BND = 'BND', // Brunei Darussalam Dollar
  BOB = 'BOB', // Bolivia Bol
  BRL = 'BRL', // Brazil Real
  BSD = 'BSD', // Bahamas Dollar
  BTN = 'BTN', // Bhutanese ngultrum
  BWP = 'BWP', // Botswana Pula
  BYN = 'BYN', // Belarus Ruble
  BZD = 'BZD', // Belize Dollar
  CAD = 'CAD', // Canada Dollar
  CDF = 'CDF', // Congolese franc
  CHF = 'CHF', // Switzerland Franc
  CLP = 'CLP', // Chile Peso
  CNY = 'CNY', // China Yuan Renminbi
  COP = 'COP', // Colombia Peso
  CRC = 'CRC', // Costa Rica Colon
  CUP = 'CUP', // Cuba Peso
  CVE = 'CVE', // Cape Verdean escudo
  CZK = 'CZK', // Czech Republic Koruna
  DKK = 'DKK', // Denmark Krone
  DJF = 'DJF', // Djiboutian franc
  DOP = 'DOP', // Dominican Republic Peso
  DZD = 'DZD', // Algerian dinar
  EGP = 'EGP', // Egypt Pound
  ERN = 'ERN', // Eritrean nakfa
  ETB = 'ETB', // Ethiopian birr
  FJD = 'FJD', // Fiji Dollar
  FKP = 'FKP', // Falkland Islands Pound
  GBP = 'GBP', // United Kingdom Pound
  GHS = 'GHS', // Ghana Cedi
  GIP = 'GIP', // Gibraltar Pound
  GTQ = 'GTQ', // Guatemala Quetzal
  GYD = 'GYD', // Guyana Dollar
  HKD = 'HKD', // Hong Kong Dollar
  HNL = 'HNL', // Honduras Lempira
  HUF = 'HUF', // Hungary Forint
  IDR = 'IDR', // Indonesia Rupiah
  ILS = 'ILS', // Israel Shekel
  INR = 'INR', // India Rupee
  IRR = 'IRR', // Iran Rial
  ISK = 'ISK', // Iceland Krona
  JMD = 'JMD', // Jamaica Dollar
  JPY = 'JPY', // Japan Yen
  KGS = 'KGS', // Kyrgyzstan Som
  KHR = 'KHR', // Cambodia Riel
  KPW = 'KPW', // DPRK Won
  KRW = 'KRW', // South Korea Won
  KYD = 'KYD', // Cayman Islands Dollar
  KZT = 'KZT', // Kazakhstan Tenge
  LAK = 'LAK', // Laos Kip
  LBP = 'LBP', // Lebanon Pound
  LKR = 'LKR', // Sri Lanka Rupee
  LRD = 'LRD', // Liberia Dollar
  MAD = 'MAD', // Moroccan Dirham
  MKD = 'MKD', // Macedonia Denar
  MNT = 'MNT', // Mongolia Tughrik
  MUR = 'MUR', // Mauritius Rupee
  MXN = 'MXN', // Mexico Peso
  MYR = 'MYR', // Malaysia Ringgit
  MZN = 'MZN', // Mozambique Metical
  NAD = 'NAD', // Namibia Dollar
  NGN = 'NGN', // Nigeria Naira
  NIO = 'NIO', // Nicaragua Cordoba Symbol
  NOK = 'NOK', // Norway Krone
  NPR = 'NPR', // Nepal Rupee
  NZD = 'NZD', // New Zealand Dollar
  OMR = 'OMR', // Oman Rial
  PAB = 'PAB', // Panama Balboa
  PEN = 'PEN', // Peru Sol
  PHP = 'PHP', // Philippines Peso
  PKR = 'PKR', // Pakistan Rupee
  PLN = 'PLN', // Poland Zloty
  PYG = 'PYG', // Paraguay Guarani
  QAR = 'QAR', // Qatar Riyal
  RON = 'RON', // Romania Leu
  RSD = 'RSD', // Serbia Dinar
  RUB = 'RUB', // Russia Ruble
  SAR = 'SAR', // Saudi Arabia Riyal
  SBD = 'SBD', // Solomon Islands Dollar
  SCR = 'SCR', // Seychelles Rupee
  SEK = 'SEK', // Sweden Krona
  SGD = 'SGD', // Singapore Dollar
  SHP = 'SHP', // Saint Helena Pound
  SOS = 'SOS', // Somalia Shilling
  SRD = 'SRD', // Suriname Dollar
  SYP = 'SYP', // Syria Pound
  THB = 'THB', // Thailand Baht
  TRY = 'TRY', // Turkey Lira
  TTD = 'TTD', // Trinidad and Tobago Dollar
  TWD = 'TWD', // Taiwan New Dollar
  UAH = 'UAH', // Ukraine Hryvnia
  UYU = 'UYU', // Uruguay Peso
  UZS = 'UZS', // Uzbekistan Som
  VND = 'VND', // Vietnam Dong
  XCD = 'XCD', // East Caribbean Dollar
  XOF = 'XOF', // West African CFA Franc
  YER = 'YER', // Yemen Rial
  ZAR = 'ZAR', // South Africa Rand
}

export interface ICash {
  amount?: number | null;
  currency?: CurrencyCode | null;
}
